import { render } from "./ClassesStudentsPending.vue?vue&type=template&id=61ce5d53&scoped=true"
import script from "./ClassesStudentsPending.vue?vue&type=script&lang=js"
export * from "./ClassesStudentsPending.vue?vue&type=script&lang=js"

import "./ClassesStudentsPending.vue?vue&type=style&index=0&id=61ce5d53&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ce5d53"]])

export default __exports__